import * as React from "react";
import { deviceType } from "./Helper";
import MemoryIcon from '@mui/icons-material/Memory';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard'; import ToggleButton from "@mui/material/ToggleButton";
import { Key } from "../data/types";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Tooltip from '@mui/material/Tooltip';
import { Version } from "./Version";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import InfoIcon from '@mui/icons-material/Info';

export const Navbar = (props: any): JSX.Element => {
    const ext: Key = props?.extMeta;
    const mcu: Key = props?.mcuMeta;
    const type: any = deviceType;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [readmeContent, setReadmeContent] = React.useState<string>('');
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        // Fetch the readme.md file
        fetch(`${process.env.PUBLIC_URL}/Readme.md`)
            .then(response => response.text())
            .then((text) => setReadmeContent(text))
            .catch(error => console.error('Error fetching readme.md:', error));
    }, []);

    const getToggleIcon = () => {
        if (props?.toggle)
            return <div><DeveloperBoardIcon /> Simplified View</div>
        return <div> <MemoryIcon /> Advanced View</div>
    }

    return <nav className="navbar sticky-top navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
            <span className="navbar-brand"><img src={`${process.env.PUBLIC_URL}/microchipLogo.png`} alt="microchip" /></span>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <div className="d-flex navbar-nav-list">
                    <FormControl className="mr-1">
                        <InputLabel id="type-select-label">Select Type</InputLabel>
                        <Select
                            labelId="type-select-label"
                            id="type-select"
                            value={props?.type}
                            label="Select Type"
                            onChange={(e) => {
                                const value = e?.target?.value;
                                if (typeof mcu === 'object' && mcu !== null) {
                                    // Optionally, you can use type assertion if you know the structure
                                    const mcuObj = mcu as Record<string, any>;
                                    const entries = Object.entries(mcuObj[value]);
                                    props?.setMcu(entries[0][0])
                                    if (entries.length > 0 && Array.isArray(entries[0][1])) {
                                        props?.setMcuVersion(entries[0][1][0])
                                        // console.log(entries[0][1][0]);
                                    }
                                    props?.setType(e?.target?.value)
                                }
                            }}
                            style={{ backgroundColor: "#fff" }}
                        >
                            {Object.keys((type)).map((a: string) =>
                                <MenuItem value={a}>{type[a]}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl className="mr-1">
                        <InputLabel id="mcu-select-label">Select Mcu</InputLabel>
                        <Select
                            labelId="mcu-select-label"
                            id="mcu-select"
                            value={props?.mcu}
                            label="Select Mcu"
                            onChange={(e) =>{
                                 props?.setMcu(e?.target?.value)
                                 props?.setMcuVersion(props?.mcuVersionInfo[e?.target?.value][0])
                            }}
                            style={{ backgroundColor: "#fff" }}
                        >
                            {Object.keys((mcu[props?.type])).map((a: string) =>
                                <MenuItem value={a}>{a}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl className="mr-1" style={{width:"150px"}}>
                        <InputLabel id="mcu-select-label">MCU PCB Version</InputLabel>
                        <Select
                            labelId="mcu-select-label"
                            id="mcu-select"
                            value={props?.mcuVersion}
                            label="Select Mcu Version"
                            onChange={(e) => props?.setMcuVersion(e?.target?.value)}
                            style={{ backgroundColor: "#fff" }}
                        >
                            {props?.mcuVersionInfo[props?.mcu].map((a: string) =>
                                <MenuItem value={a}>{a}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl className="mr-1">
                        <InputLabel id="ext-select-label">Select Extenstion</InputLabel>
                        <Select
                            labelId="ext-select-label"
                            id="ext-select"
                            value={props?.ext}
                            label="Select Extenstion"
                            onChange={(e) => props?.setExt(e?.target?.value)}
                            style={{ backgroundColor: "#fff" }}
                        >
                            {Object.keys((ext)).map((a: string) =>
                                <MenuItem value={a}>{a}</MenuItem>)}
                        </Select>
                    </FormControl>
                    {/* <select name="type" className="form-select form-control me-2" aria-label="Default select example" onChange={(e) => props?.setType(e?.currentTarget?.value)}>
                            {Object.keys((type)).map((a: string) => <option value={a}>{type[a]}</option>)}
                        </select>
                        <select name="mcu" className="form-select form-control me-2" aria-label="Default select example" onChange={(e) => props?.setMcu(e?.currentTarget?.value)}>
                            {Object.keys((mcu)).map((a) => <option value={a}>{a}</option>)}
                        </select>
                        <select name="ext" className="form-select form-control me-2" aria-label="Default select example" onChange={(e) => props?.setExt(e?.currentTarget?.value)}>
                            {Object.keys((ext)).map((a) => <option value={a}>{a}</option>)}
                        </select> */}
                    <Tooltip title={`Switch to ${props?.toggle ? "Simplified" : "Advanced"} view`}>
                        <ToggleButton
                            value=""
                            selected={props?.toggle}
                            className="advanced-view-button"
                            onChange={() => {
                                props?.setToggle(!props?.toggle);
                            }}
                        >
                            {/* {props?.toggle ? <MemoryIcon /> : <DeveloperBoardIcon />} */}
                            {getToggleIcon()}
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title={`Version Info`}>
                        <Button
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                            className="advanced-view-button v-info"
                        >
                            <InfoIcon />
                        </Button>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        slotProps={{
                            paper: {
                                style: { maxHeight: 350, width: '350' },
                            },
                        }}
                    >
                        <Version content={readmeContent} />
                    </Menu>
                </div>
            </div>
        </div >
    </nav >
}